import { createComponent, ElementWithProps } from '@carvana/merch-components';
import cx from 'classnames';

export const TimerContainer = createComponent('div', {
  className: 'grid grid-cols-1 grid-rows-1 items-center justify-items-center'
});

export const ProgressMeter = createComponent<
  ElementWithProps<{
    diameter?: number;
    percentage: number;
    strokeWidth?: number;
  }>
>('svg', ({ diameter = 80, percentage, strokeWidth = 5 }) => ({
  className: cx(
    '[--diameter:var(--unit-diameter)] sm:[--diameter:calc(var(--unit-diameter)*1.5)]',
    '[--stroke-width:var(--unit-stroke-width)] sm:[--stroke-width:calc(var(--unit-stroke-width)*2)]',
    '[--radius:calc((var(--diameter)-var(--stroke-width))*0.5px)]',
    'col-start-1 col-end-2 row-start-1 row-end-2 aspect-square w-[calc(var(--diameter)*1px)] -scale-x-100 [object-view-box:0_0_var(--diameter)_var(--diameter)]'
  ),
  style: {
    '--unit-diameter': diameter,
    '--unit-stroke-width': strokeWidth,
    '--percentage': percentage
  }
}));

export const ProgressMeterText = createComponent('div', {
  className: 'col-start-1 col-end-2 row-start-1 row-end-2 text-center'
});

const circleClasses =
  'fill-none stroke-[calc(var(--stroke-width)*1px)] [cx:calc(var(--diameter)*0.5px)] [cy:calc(var(--diameter)*0.5px)] [r:var(--radius)]';

export const TimerBackground = createComponent('circle', {
  className: cx(circleClasses, 'stroke-border-subtle')
});

export const TimerForeground = createComponent('circle', {
  className: cx(
    circleClasses,
    '[--circumference:calc(2*3.14159265359*var(--radius))]',
    '[--dash-length:calc(var(--percentage)*var(--circumference))]',
    '[--gap-length:calc(var(--circumference)-var(--dash-length))]',
    'stroke-border-success [stroke-dasharray:var(--dash-length)_var(--gap-length)] [stroke-linecap:round] [transform:matrix(0,-1,1,0,0,var(--diameter))]'
  )
});
